import { render, staticRenderFns } from "./DocumentMailModal.vue?vue&type=template&id=80423992"
import script from "./DocumentMailModal.vue?vue&type=script&lang=js"
export * from "./DocumentMailModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports